import { Routes } from '@angular/router';

import { ShopComponent } from './shop/shop.component';
import { PagesComponent } from './pages/pages.component';
import { ElementsComponent } from './elements/elements.component';
import { AdminComponent } from './admin/admin.component';
import { VendorComponent } from './vendor/vendor.component';
import { AdminEditorComponent } from './admin-editor/admin-editor.component';
import { InterviewerComponent } from './interviewer/interviewer/interviewer.component';
import { CommonLoginComponent } from './common-login/common-login.component';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { RoleGuard } from './services/role.guard';
import { OnlineExamComponent } from './exams/online-exam/online-exam.component';
import { VendorRegistrationComponent } from './vendor/vendor-registration/vendor-registration.component';
import { ImmediateHiringsComponent } from './immediate-hirings/immediate-hirings.component';
import { PlansPriceComponent } from './admin/plans-price/plans-price.component';
import { VendorSuccessPageComponent } from './vendor/vendor-success-page/vendor-success-page.component';
import { PrivacyPolicyComponent } from './shared/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './shared/terms-and-conditions/terms-and-conditions.component';
import { AdvertiseDetailsViewComponent } from './advertise-details-view/advertise-details-view.component';
import { FaqsComponent } from './faqs/faqs.component';
import { PricingPolicyComponent } from './shared/pricing-policy/pricing-policy.component';
import { RefundPolicyComponent } from './shared/refund-policy/refund-policy.component';
import { CancellationPolicyComponent } from './shared/cancellation-policy/cancellation-policy.component';
import { ShippingPolicyComponent } from './shared/shipping-policy/shipping-policy.component';
import { DetailBlogViewComponent } from './detail-blog-view/detail-blog-view.component';
import { ValidatePaymentsComponent } from './validate-payments/validate-payments.component';
import { PlanDetailPageComponent } from './admin/plans-price/plan-detail-page/plan-detail-page.component';
import { VendorForgotPasswordComponent } from './vendor/vendor-forgot-password/vendor-forgot-password.component';
import { VerifyVendorEmailComponent } from './vendor/verify-vendor-email/verify-vendor-email.component';
import { VerifyBusinessPartnerEmailComponent } from './verify-business-partner-email/verify-business-partner-email.component';
import { SuccessOnlineExamComponent } from './exams/online-exam/success-online-exam/success-online-exam.component';
import { JobSeekerComponent } from './job-seeker/job-seeker/job-seeker.component';
import { JobLandingComponent } from './job-landing/job-landing.component';
import { SupportDocumentsComponent } from './vendor/support-documents/support-documents.component';
import { TestFeature } from './vendor/test-feature/test-feature';
import { EnterpriseCustomBrand } from './custom-brand/enterprise-custom-brand/enterprise-custom-brand';
import { StartupsCustomBrand } from './custom-brand/startups-custom-brand/startups-custom-brand';
import { GlobalTeamsCustomBrand } from './custom-brand/global-teams-custom-brand/global-teams-custom-brand';
import { RemoteWorkCustomBrand } from './custom-brand/remote-work-custom-brand/remote-work-custom-brand';
import { ManufacturingCustomBrand } from './custom-brand/manufacturing-custom-brand/manufacturing-custom-brand';
import { HealthcareCustomBrand } from './custom-brand/healthcare-custom-brand/healthcare-custom-brand';
import { PartnersCustomBrand } from './custom-brand/partners-custom-brand/partners-custom-brand';
import { ContactCustomBrand } from './custom-brand/contact-custom-brand/contact-custom-brand';
import { AboutusCustomBrand } from './custom-brand/aboutus-custom-brand/aboutus-custom-brand';
import { EmpManagmentFooter } from './custom-brand/emp-managment-footer/emp-managment/emp-managment-footer';
import { PayrollCustomBrand } from './custom-brand/payroll-custom-brand/payroll-custom-brand';
import { AttendanceCustomBrand } from './custom-brand/attendance-custom-brand/attendance-custom-brand';
import { PerformanceCustomBrand } from './custom-brand/performance-custom-brand/performance-custom-brand';
import { RecruitmentCustomBrand } from './custom-brand/recruitment-custom-brand/recruitment-custom-brand';
import { AiAssistantCustomBrand } from './custom-brand/ai-assistant-custom-brand/ai-assistant-custom-brand';
import { DocumentaionCustomBrand } from './custom-brand/documentaion-custom-brand/documentaion-custom-brand';
import { ApireferenceCustom } from './custom-brand/apireference-custom/apireference-custom';
import { BlogCustom } from './custom-brand/blog-custom/blog-custom';
import { HrAcademy } from './custom-brand/hr-academy/hr-academy';
import { Webinars } from './custom-brand/webinars/webinars';
import { StatusPage } from './custom-brand/status-page/status-page';
import { CareersCustomBrand } from './custom-brand/careers-custom-brand/careers-custom-brand';
import { PressKitCustom } from './custom-brand/press-kit-custom/press-kit-custom';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'shop',
    component: ShopComponent,
    loadChildren: () => import('./shop/shop.module').then((m) => m.ShopModule),
  },
  {
    path: 'pages',
    component: PagesComponent,
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'elements',
    component: ElementsComponent,
    loadChildren: () => import('./elements/elements.module').then((m) => m.ElementsModule),
  },
  {
    path: 'admin',
    component: AdminComponent,
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'vendor',
    component: VendorComponent,
    canActivate: [RoleGuard],
    data: { expectedRole: ['VENDOR', 'VENDOR_EMP'] },
    loadChildren: () => import('./vendor/vendor.module').then((m) => m.VendorModule),
  },
  {
    path: 'interviewer',
    component: InterviewerComponent,
    canActivate: [RoleGuard],
    data: { expectedRole: ['INTERVIEWER'] },
    loadChildren: () => import('./interviewer/interviewer/interviewer.module').then((m) => m.InterviewerModule),
  },
  { path: 'login', component: CommonLoginComponent },
  { path: 'register', component: VendorRegistrationComponent },
  {
    path: 'online-exam',
    component: OnlineExamComponent,
    loadChildren: () => import('./exams/exam.module').then((m) => m.ExamModule),
  },
  {
    path: 'online-exam-success',
    component: SuccessOnlineExamComponent,
    loadChildren: () => import('./exams/exam.module').then((m) => m.ExamModule),
  },
  { path: 'immediate-hirings', component: ImmediateHiringsComponent },
  { path: 'products-old', component: PlansPriceComponent },
  {
    path: 'job-seeker',
    component: JobSeekerComponent,
    loadChildren: () => import('./job-seeker/job-seeker/job-seeker.module').then((m) => m.JobSeekerModule),
  },
  { path: 'privacy', component: PrivacyPolicyComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'vendor-success', component: VendorSuccessPageComponent },
  { path: 'advertise-view/:slug', component: AdvertiseDetailsViewComponent },
  { path: 'faqs', component: FaqsComponent },
  { path: 'pricing-policy', component: PricingPolicyComponent },
  { path: 'refund-policy', component: RefundPolicyComponent },
  { path: 'cancellation-policy', component: CancellationPolicyComponent },
  { path: 'shipping-policy', component: ShippingPolicyComponent },
  { path: 'job-hunting-mistakes', component: DetailBlogViewComponent },
  { path: 'product-details-old', component: PlanDetailPageComponent },
  { path: 'payments/:k', component: ValidatePaymentsComponent },
  { path: 'forgot-password', component: VendorForgotPasswordComponent },
  { path: 'jobs-landing', component: JobLandingComponent },
  { path: 'verify-vendor', component: VerifyVendorEmailComponent },
  { path: 'verify-business-partner', component: VerifyBusinessPartnerEmailComponent },
  { path: 'support-documents', component: SupportDocumentsComponent },
  { path: 'all-features', component: TestFeature },
  // { path: 'dummy-test', component: TestFeature },
  { path: 'enterprise-custom-brand', component: EnterpriseCustomBrand },
  { path: 'startups-custom-brand', component: StartupsCustomBrand },
  { path: 'global-custom-brand', component: GlobalTeamsCustomBrand },
  { path: 'remote-custom-brand', component: RemoteWorkCustomBrand },
  { path: 'manufacturing-custom-brand', component: ManufacturingCustomBrand },
  { path: 'healthcare-custom-brand', component: HealthcareCustomBrand },
  { path: 'partners-custom-brand', component: PartnersCustomBrand },
  { path: 'contact-custom-brand', component: ContactCustomBrand },
  { path: 'about-us-custom', component: AboutusCustomBrand },
  { path: 'emp-management-footer', component: EmpManagmentFooter },
  { path: 'payroll-custom-brand', component: PayrollCustomBrand },
  { path: 'attendance-custom-brand', component: AttendanceCustomBrand },
  { path: 'performance-custom-brand', component: PerformanceCustomBrand },
  { path: 'recruitment-custom-brand', component: RecruitmentCustomBrand },
  { path: 'ai-assistant-custom-brand', component: AiAssistantCustomBrand },
  { path: 'documentation-custom-brand', component: DocumentaionCustomBrand},
  { path: 'api-reference-custom', component: ApireferenceCustom },
  { path: 'blog-custom', component: BlogCustom },
  { path: 'hr-academy', component: HrAcademy },
  { path: 'webinars', component: Webinars },
  { path: 'status-page', component: StatusPage },
  { path: 'careers-custom-brand', component: CareersCustomBrand },
  { path: 'press-kit-custom', component: PressKitCustom },
  { path: '**', redirectTo: 'home/fashion' },
];
